import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight, Loader2 } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import { SearchBar } from '../components/SearchBar';
import { useStore, useBlogStore } from '../store';

// ייבוא של RelatedPosts
import RelatedPosts from "../components/RelatedPosts"; 

export const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { query, setQuery } = useStore();
  const { posts, loading, error, fetchPosts } = useBlogStore();

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const post = posts.find(p => p.slug === slug);

  const handleSearch = (newQuery: string) => {
    setQuery(newQuery);
    if (newQuery.trim()) {
      navigate('/', { replace: true });
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="max-w-4xl mx-auto py-12 px-4 text-center">
        <p className="text-red-600 mb-4">{error || 'המאמר המבוקש לא נמצא'}</p>
        <Link 
          to="/blog"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
        >
          <ArrowRight className="w-4 h-4 ml-1" />
          חזרה לבלוג
        </Link>
      </div>
    );
  }

  const formattedDate = new Date(post.published_at).toLocaleDateString('he-IL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <Link 
          to="/blog"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
        >
          <ArrowRight className="w-4 h-4 ml-1" />
          חזרה לבלוג
        </Link>
        <div className="w-full md:w-auto md:flex-1 md:max-w-xl">
          <SearchBar 
            value={query}
            onChange={handleSearch}
            placeholder="מתי כדאי...?"
          />
        </div>
      </div>

      <article className="bg-white rounded-lg shadow-lg p-8">
        {post.image_url && (
          <img 
            src={post.image_url}
            alt={post.title}
            className="w-full h-auto rounded-lg mb-8"
          />
        )}

        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          {post.title}
        </h1>

        <div className="flex items-center gap-4 text-gray-500 text-sm mb-8">
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            <span>{formattedDate}</span>
          </div>
          <span>מאת {post.author}</span>
        </div>

        <div className="prose prose-lg max-w-none">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
      </article>

      {/* הוספת הקומפוננטה של המאמרים המומלצים */}
      <RelatedPosts currentSlug={post.slug} />
    </div>
  );
};
